import React from 'react';
import { Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import Table from '../ui/Table';

const DetallesClienteCell = ({ original, onVerDetalle }) => (
  <Button color="success" onClick={() => onVerDetalle(original.headquarter, original.codigo)}>
    Detalles
  </Button>
);
DetallesClienteCell.propTypes = {
  original: PropTypes.shape({
    headquarter: PropTypes.string.isRequired,
    codigo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  onVerDetalle: PropTypes.func.isRequired,
};

const TablaClientes = ({ data }) => {
  const navigate = useNavigate();

  const columns = [
    {
      Header: 'Código',
      accessor: 'codigo',
    },
    {
      Header: 'Nombre Fiscal',
      accessor: 'nombreFiscal',
    },
    {
      Header: 'Nombre Comercial',
      accessor: 'nombreComercial',
    },
    {
      Header: 'CIF',
      accessor: 'cif',
    },
    {
      Header: 'Correo Electrónico',
      accessor: 'email',
    },
    {
      Header: 'Teléfono',
      accessor: 'telefono',
    },
    {
      Header: 'Empresa',
      accessor: 'headquarter',
    },
    {
      Header: 'Acciones',
      CellComponent: DetallesClienteCell,
      cellProps: {
        onVerDetalle: (headquarter, codigo) =>
          navigate(`/clientes/${headquarter}/${codigo}/detalles`),
      },
      sortable: false,
      filterable: false,
      width: 120,
    },
  ];

  return (
    <Table
      data={data}
      columns={columns}
      defaultPageSize={10}
      className="-striped -highlight mt-5 text-center"
    />
  );
};

TablaClientes.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default TablaClientes;
